import React from 'react';
import { LID_COLOR, LID_HI } from './gachaData';

const GachaMachine = ({ phase, drawColor, balls, onCrank, onCapsuleClick }) => {
  const cranking = phase === 'cranking';
  const showBall = phase === 'dropping' || phase === 'ready';
  const ballAnim =
    phase === 'dropping'
      ? 'ibgDrop 0.95s cubic-bezier(0.34,0.02,0.4,1) both'
      : 'ibgPulse 2.4s ease-in-out 0.2s infinite';

  return (
    <div
      style={{
        position: 'relative',
        width: 'min(300px, 74vw, 46vh)',
        aspectRatio: '5 / 7',
        animation: cranking ? 'ibgJiggle 0.85s ease-in-out both' : 'none',
      }}
    >
      {/* 바닥 그림자 */}
      <div
        style={{
          position: 'absolute',
          bottom: '-2%',
          left: '8%',
          width: '84%',
          height: '5%',
          borderRadius: '50%',
          background: 'rgba(71, 66, 56, 0.2)',
          filter: 'blur(10px)',
        }}
      />
      {/* 하단 몸체 */}
      <div
        style={{
          position: 'absolute',
          top: '60.5%',
          left: '14%',
          width: '72%',
          height: '37.5%',
          background:
            'linear-gradient(180deg, var(--c-n-200), var(--c-n-300) 50%, var(--c-n-400))',
          clipPath:
            'polygon(17% 0, 83% 0, 96% 90%, 92% 100%, 8% 100%, 4% 90%)',
          boxShadow:
            'inset 0 -14px 22px rgba(71, 66, 56, 0.3), inset 0 6px 8px rgba(255, 255, 255, 0.55)',
        }}
      />
      {/* 목 칼라 */}
      <div
        style={{
          position: 'absolute',
          top: '57.5%',
          left: '21%',
          width: '58%',
          height: '4.5%',
          background:
            'linear-gradient(180deg, var(--c-n-300), var(--c-n-500) 55%, var(--c-n-700))',
          borderRadius: 12,
          boxShadow: 'var(--sh-sm)',
        }}
      />
      {/* 유리 돔 */}
      <div
        style={{
          position: 'absolute',
          top: '6.5%',
          left: '8%',
          width: '84%',
          aspectRatio: '1',
          borderRadius: '50%',
          background:
            'linear-gradient(160deg, rgba(255,255,255,0.4), rgba(255,255,255,0.08) 42%, rgba(161,151,134,0.3))',
          border: '2px solid rgba(161, 151, 134, 0.45)',
          boxShadow:
            'inset 0 -16px 32px rgba(100, 92, 80, 0.25), inset 10px 16px 26px rgba(255,255,255,0.5), 0 20px 44px rgba(90, 60, 40, 0.18)',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: '4%',
            borderRadius: '50%',
            overflow: 'hidden',
            animation: cranking ? 'ibgTumble 0.85s ease-in-out both' : 'none',
          }}
        >
          {balls.map((b, i) => (
            <div
              key={i}
              style={{
                position: 'absolute',
                left: `${b.l}%`,
                top: `${b.t}%`,
                width: `${b.s}%`,
                aspectRatio: '1',
                borderRadius: '50%',
                background: `radial-gradient(circle at 32% 26%, rgba(255,255,255,0.95), rgba(255,255,255,0) 40%), linear-gradient(180deg, ${b.c} 0 52%, var(--c-n-100) 52%)`,
                boxShadow:
                  'inset -3px -7px 12px rgba(46, 43, 37, 0.35), 0 4px 8px rgba(46, 43, 37, 0.25)',
                border: '1px solid rgba(130, 121, 106, 0.35)',
              }}
            />
          ))}
        </div>
        {/* 유리 반사광 */}
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            background:
              'radial-gradient(circle at 30% 22%, rgba(255,255,255,0.4), rgba(255,255,255,0) 24%), radial-gradient(circle at 74% 82%, rgba(255,255,255,0.15), rgba(255,255,255,0) 22%)',
            pointerEvents: 'none',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '37%',
            width: '100%',
            textAlign: 'center',
            fontFamily: 'var(--f-heading)',
            fontSize: 'clamp(15px, 4.2vw, 23px)',
            lineHeight: 1.2,
            color: 'rgba(255,255,255,0.9)',
            letterSpacing: '0.04em',
            textShadow: '0 1px 3px rgba(71, 66, 56, 0.3)',
            pointerEvents: 'none',
          }}
        >
          Koready
          <br />
          Club
        </div>
      </div>
      {/* 뚜껑 */}
      <div
        style={{
          position: 'absolute',
          top: '1%',
          left: '30%',
          width: '40%',
          height: '9%',
          background: `linear-gradient(180deg, ${LID_HI}, ${LID_COLOR} 70%)`,
          borderRadius: '50% 50% 22% 22% / 95% 95% 25% 25%',
          boxShadow:
            '0 6px 14px rgba(61, 71, 43, 0.35), inset 0 3px 5px rgba(255,255,255,0.35)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '-2.5%',
          left: '46.5%',
          width: '7%',
          aspectRatio: '1',
          borderRadius: '50%',
          background: `linear-gradient(160deg, ${LID_HI}, ${LID_COLOR})`,
          boxShadow: '0 3px 6px rgba(61, 71, 43, 0.35)',
        }}
      />

      {/* 크랭크 */}
      <div
        onClick={onCrank}
        title='Pull the crank'
        className='ibg-crank-hit'
        style={{
          position: 'absolute',
          top: '65.5%',
          left: '35%',
          width: '30%',
          height: '16.5%',
          zIndex: 4,
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '22%',
            background:
              'linear-gradient(150deg, var(--c-n-200), var(--c-n-500) 60%, var(--c-n-600))',
            boxShadow:
              '0 6px 12px rgba(90, 60, 40, 0.28), inset 0 2px 3px rgba(255,255,255,0.8)',
          }}
        />
        <div
          style={{
            position: 'absolute',
            inset: '13%',
            borderRadius: '22%',
            background: 'linear-gradient(145deg, var(--c-n-300), var(--c-n-600))',
            boxShadow:
              'inset 0 2px 4px rgba(255,255,255,0.7), inset 0 -3px 6px rgba(71, 66, 56, 0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: cranking
              ? 'ibgCrank 0.85s cubic-bezier(0.6,0.05,0.35,1) both'
              : 'none',
          }}
        >
          <div
            style={{
              width: '68%',
              height: '20%',
              borderRadius: 999,
              background:
                'linear-gradient(180deg, var(--c-n-300), var(--c-n-600))',
              boxShadow: '0 2px 3px rgba(71, 66, 56, 0.3)',
            }}
          />
          <div
            style={{
              position: 'absolute',
              width: '16%',
              aspectRatio: '1',
              borderRadius: '50%',
              background:
                'linear-gradient(145deg, var(--c-n-100), var(--c-n-500))',
              boxShadow: '0 1px 2px rgba(71, 66, 56, 0.4)',
            }}
          />
        </div>
      </div>
      {/* 배출구 */}
      <div
        style={{
          position: 'absolute',
          top: '84.5%',
          left: '43.5%',
          width: '13%',
          height: '8%',
          background: 'linear-gradient(180deg, var(--c-n-700), var(--c-n-900))',
          borderRadius: '14% 14% 45% 45%',
          boxShadow: 'inset 0 4px 7px rgba(0,0,0,0.5)',
          zIndex: 2,
        }}
      />

      {/* 뽑힌 캡슐 */}
      {showBall && (
        <div
          onClick={onCapsuleClick}
          className='ibg-capsule'
          style={{
            position: 'absolute',
            top: '77%',
            left: '40.5%',
            width: '19%',
            aspectRatio: '1',
            cursor: 'pointer',
            zIndex: 6,
            animation: ballAnim,
          }}
        >
          <div
            className='ibg-capsule-ball'
            style={{
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              background: `radial-gradient(circle at 32% 26%, rgba(255,255,255,0.95), rgba(255,255,255,0) 42%), linear-gradient(180deg, ${drawColor} 0 52%, var(--c-n-100) 52%)`,
              boxShadow:
                'inset -3px -8px 12px rgba(71, 66, 56, 0.28), 0 8px 16px rgba(71, 66, 56, 0.32)',
            }}
          />
        </div>
      )}
    </div>
  );
};

export default GachaMachine;
